import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { appAnalytics } from 'analytics';
import { OnboardingScreenOpened } from 'analytics/AllEvents';
import { pushWithSearchQuery } from 'utils';
import { Question } from 'onboarding/question/Question';
import { getQuestionComponent } from 'onboarding/question/helper';
import { StepperWrapper } from 'onboarding/StepperWrapper';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import { useFeatures } from 'useFeatures';
import { getQuestionsOrder } from 'onboarding/data/QuestionsOrder/QuestionsOrder';

import { getQuestionsMeta } from 'onboarding/data/meta';
import { LivenHeaderWrapper } from './LivenHeaderWrapper';
import styles from './styles.module.scss';

type OnboardingParams = {
  questionId: QuestionIds;
};

export const Onboarding = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const features = useFeatures();

  const {
    isAdhdTest,
    isDefaultOnboarding,
    isGadTest,
    isFlexibleOmitViewEventsFlow,
    isMeqResultAnimalFlow,
    isMeqResultV2Flow,
    isLivenOnboardingFlow,
    isRecommendedByRmeqQ5Flow,
  } = features;

  const questionMeta = getQuestionsMeta(
    isAdhdTest,
    isGadTest,
    isDefaultOnboarding,
    isRecommendedByRmeqQ5Flow,
  );

  const { questionId } = useParams<OnboardingParams>();
  const [className, setClassName] = React.useState('');

  const questionsOrder = getQuestionsOrder(features);

  useEffect(() => {
    setClassName('');
  }, [location, questionId]);

  useEffect(() => {
    if (QuestionIds[questionId] && !isFlexibleOmitViewEventsFlow) {
      appAnalytics.trackEvent(
        new OnboardingScreenOpened(questionMeta[questionId].id),
      );
    }
  }, [questionId]);

  if (!QuestionIds[questionId]) {
    dispatch(pushWithSearchQuery(`/onboarding/${questionsOrder[0]}`));
    return null;
  }

  const question: Question = questionMeta[questionId];
  const QuestionComponent = getQuestionComponent(
    question,
    isMeqResultAnimalFlow,
    isMeqResultV2Flow,
  );
  return (
    <div
      className={`${styles.container} ${styles[className]} ${
        isLivenOnboardingFlow ? styles.liven : ''
      }`}
    >
      {question.hasStepper && !isLivenOnboardingFlow && (
        <StepperWrapper questionId={questionId} className={className} />
      )}
      {isLivenOnboardingFlow && (
        <LivenHeaderWrapper
          questionId={questionId}
          className={className}
          withStepper={question.hasStepper}
        />
      )}
      {/* {question.hasHeader && isLivenOnboardingFlow && <LivenLogoHeader />} */}
      {QuestionComponent && <QuestionComponent question={question} />}
    </div>
  );
};
